// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"PerfOrderDetailsSkeletonDataGrid_skeletonContainer__G4G9T","skeletonRow":"PerfOrderDetailsSkeletonDataGrid_skeletonRow__Z0GgC"};